import { createFileRoute, redirect } from '@tanstack/react-router'

// Preserve bookmarks while keeping a single list and editor.
export const Route = createFileRoute('/compositions')({
  beforeLoad: ({ location }) => {
    const id = Number(new URLSearchParams(location.searchStr).get('id'))
    throw redirect({ to: '/flows', search: { ...(Number.isSafeInteger(id) && id > 0 ? { id, view: 'layout' as const } : {}) }, replace: true })
  },
})
